import { render, staticRenderFns } from "./substituteDetail.vue?vue&type=template&id=2d6eb4ec&scoped=true&"
import script from "./substituteDetail.vue?vue&type=script&lang=js&"
export * from "./substituteDetail.vue?vue&type=script&lang=js&"
import style0 from "./substituteDetail.vue?vue&type=style&index=0&id=2d6eb4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6eb4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6eb4ec')) {
      api.createRecord('2d6eb4ec', component.options)
    } else {
      api.reload('2d6eb4ec', component.options)
    }
    module.hot.accept("./substituteDetail.vue?vue&type=template&id=2d6eb4ec&scoped=true&", function () {
      api.rerender('2d6eb4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/substituteDetail.vue"
export default component.exports